import HeaderDynamicData from './HeaderDynamicData';

export default HeaderDynamicData;
